export enum SelectionButtonSizeEnum {
  Small,
  Big,
}
